import request from "./clientsApi";
import { API_ROUTES } from "../config/baseURL";
import { toast } from "react-toastify";


export const apiSaveResultado = (payload) => {
  return request(API_ROUTES.cargarResultado, {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

// ==============================
// 📌 Obtener complemento del cons
// ==============================
export const fetchComplemento = async (cons, Identificacion) => {
  try { 
    const response = await request(API_ROUTES.ComplementoCons(cons, Identificacion), {method: "GET"});
    const result = await response.json();

    if (result?.success === false) {
      toast.error(result.message || "Ocurrió un error.");
      return [];
    }
    
    return result.data;
  } catch (error) {
    console.error("Error en fetchComplemento:", error);
    return null;
  }
};

// ========================================
// 📌 Filtrar prestadores por búsqueda texto
// ========================================
export const filterPrestadores = (prestadores, texto) => {
  if (!texto) return prestadores.slice(0, 100);

  return prestadores
    .filter((p) =>
      p.RAZON_SOCIAL.toLowerCase().includes(texto.toLowerCase())
    )
    .slice(0, 100);
};

// ========================================================
// 📌 Validar valores numéricos según valores_normales
// ========================================================
export const validateResultadoNumerico = (resultado, complemento) => {
  if (!complemento?.valores_normales?.[0] || isNaN(resultado)) return null;

  const valores = complemento.valores_normales[0];
  const min = parseFloat(valores.Valor_Minimo);
  const max = parseFloat(valores.Valor_maximo);
  const valor = parseFloat(resultado);

  if (valor < min || valor > max) {
    return { min, max };
  }

  return null;
};

// ========================================================
// 📌 Guardar resultado con POST
// ========================================================
export const saveResultado = async (payload) => {
  try {
    const response = await request(API_ROUTES.saveResult, {
      method: "POST",
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    
    if (data?.success === false) {
      toast.error(data.message || "Ocurrió un error.");
      return false;
    }

    return true;
  } catch (error) {
    console.error("Error en saveResultado:", error);
    return { error: "No se pudo guardar el resultado" };
  }
};
